<template>
    <div class="boolland_index">
        <div class="hero_section">            
            <div class="hero_content" ref="heroSection">
                <div class="hero_desc text-center text-md-end">Welcome</div>
                <h1 class="hero_title mega_text">boolland</h1>
                <div class="hero_desc text-center text-md-start">Est. 2023</div>
            </div>
            <div class="hero_footer d-flex align-items-end">                                
                <div class="col-2 col-md-3">
                    <span class="hero_footer_nav d-none d-md-block">↓&nbsp;&nbsp;&nbsp;&nbsp;Explore More</span>
                </div>
                <div class="col-8 col-md-6 text-center">
                    <h2 class="hero_footer_slogan">We Code Your Vision</h2>
                    <h3 class="hero_footer_desc font-monospace">Ecommerce, systems & apps — built for growth.</h3>
                </div>
                <div class="col-2 col-md-3 text-end">
                    <span class="hero_footer_nav d-none d-md-block">Our Portfolio</span>
                </div>
            </div>            
        </div>
        <div class="about_section">
            <div class="about_content">
                <div class="about_eyebrow">
                    <h2 class="about_title small font-monospace">&lt;What We Do/&gt;</h2>
                </div>
                <!-- <h3 class="about_us_desc h3" ref="aboutUsDesc">Our core services are <br class="d-block d-md-none">designed to take&nbsp;<br class="d-none d-md-block">your <br class="d-block d-md-none">brand from concept to <br class="d-block d-md-none">launch —&nbsp;<br class="d-none d-md-block">and beyond.</h3> -->
                <h3 class="about_us_desc h3" ref="aboutUsDesc">As your premium <br class="d-block d-md-none">technical partner, we <br>don't just build software <br class="d-block d-md-none">— we engineer <br class="d-none d-md-block">your <br class="d-block d-md-none">vision into a scalable <br class="d-block d-md-none">reality, from <br class="d-none d-md-block">the first line <br class="d-block d-md-none">of code to global launch.</h3>
                <!-- <h3 class="about_us_desc h3" ref="aboutUsDesc">Your premium technical partner in turning ideas into scalable digital products.</h3> -->
                <!-- <h3 class="about_us_desc h3" ref="aboutUsDesc">Our core services are designed to take your brand from concept to launch — and beyond.</h3> -->
            </div>
        </div>
        <div class="service_section d-flex flex-wrap">            
            <div class="service_section_title_wrapper col-12 col-md-6">
                <h2 class="service_section_title h1 position-sticky">Our Services</h2>
            </div>
            <div class="service_list col-12 col-md-6">
                <div class="service_block">
                    <h3 class="service_title h4">E-Commerce Store Development</h3>
                    <div class="service_desc font-monospace">High-performance Shopify stores built to scale with your sales. We combine custom UI/UX design with bespoke theme development to create a unique brand look. Custom apps extend Shopify’s capabilities, providing the tailored technical solutions your brand needs to optimize operations and deliver a seamless customer experience beyond the standard template.</div>
                </div>
                <div class="service_block">
                    <h3 class="service_title h4">Custom Build Website</h3>
                    <div class="service_desc font-monospace">Bespoke websites crafted from the ground up. <br>Performance-first architecture, immersive interactions, and pixel-perfect execution that sets your brand apart.</div>
                </div>
                <div class="service_block">
                    <h3 class="service_title h4">Mobile Apps Development</h3>
                    <div class="service_desc font-monospace">Cross-platform and native mobile applications with fluid UX, offline capabilities, and seamless backend integration that users love.</div>
                </div>
            </div>
        </div>
        <div class="portfolio_section">
            <div class="portfolio_wrapper d-flex flex-wrap justify-content-center">                
                <a class="project_box" v-for="project in projects" :key="project.name" :title="project.name" :href="project.url" :style="`--project-background: ${project.background_color}` " target="_blank">
                    <img :src="project.logo_url" :alt="project.name" :style="`--project-filter: ${project.filter};` " />
                </a>                
            </div>
        </div>
        <div class="calendly_section">
            <div class="calendly_cta_wrapper text-center">
                <h2 class="h2">Ready to build <br>something <span class="gradient-glow">extraordinary</span>?</h2>
                <button class="calendly_cta" ref="ctaBtn" @click="handleCTAClick" type="button">Let's Talk!</button>
            </div>
            <div class="calendly_overlay calendly_hide">
                <div class="calendly_wrapper">
                    <!-- Calendly inline widget begin -->
                    <div ref="calendlyWidget" :data-url="calendlyUrl" style="min-width:100vw;height:100vh;"></div>
                    <!-- Calendly inline widget end -->
                     <button class="button">Back to Homepage</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            projects: [
                {
                    name: 'ZUS Coffee',
                    url: 'https://shop.zuscoffee.com/',
                    logo_url: require('@/assets/images/project_logo/zus_logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(1)"
                },
                {
                    name: 'Montigo',
                    url: 'http://shopmontigo.com/',
                    logo_url: require('@/assets/images/project_logo/Montigo_logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },
                {
                    name: 'OIYO',
                    url: 'https://www.oiyoshop.com/',
                    logo_url: require('@/assets/images/project_logo/OIYO_logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },
                {
                    name: 'Hoppi',
                    url: 'https://www.heyhoppi.com.my/',
                    logo_url: require('@/assets/images/project_logo/Hoppi_logo.png'),
                    background_color: "#FAFDF1",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },
                {
                    name: 'Over Bottle',
                    url: 'https://overmalaysia.com/',
                    logo_url: require('@/assets/images/project_logo/OverMalaysia_logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },
                {
                    name: 'Caketella',
                    url: 'https://www.caketella.com/',
                    logo_url: require('@/assets/images/project_logo/CakeTella_Logo_Text.png'),
                    background_color: "#f9f5e7",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },
                {
                    name: 'Nature\'s Comeback',
                    url: 'https://www.natures-comeback.com/',
                    logo_url: require('@/assets/images/project_logo/Nature_Comeback_Logo.png'),
                    background_color: "#FDFBE7",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },
                {
                    name: 'Fiskor',
                    url: 'https://www.fiskor.co/',
                    logo_url: require('@/assets/images/project_logo/Fiskor_logo.png'),
                    background_color: "#0066FF",
                    filter: "grayscale(100%) brightness(1) invert(0)"
                },
                {
                    name: 'HYGR',
                    url: 'https://hygr.my/',
                    logo_url: require('@/assets/images/project_logo/HYGR_Logo_White.png'),
                    background_color: "#10301f",
                    filter: ""
                },
                {
                    name: 'Russell Taylors',
                    url: 'https://www.russelltaylors.co.uk/',
                    logo_url: require('@/assets/images/project_logo/RussellTaylors_logo.png'),
                    background_color: "#F04E23",
                    filter: "grayscale(100%) brightness(0) invert(1)"           
                },
                {
                    name: 'Crownlivin',
                    url: 'https://crownlivin.com.my/',
                    logo_url: require('@/assets/images/project_logo/Crownlivin_Logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },                                                               
                {
                    name: 'Aemis',
                    url: 'https://aemis.store/',
                    logo_url: require('@/assets/images/project_logo/Aemis_logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },       
                {
                    name: 'Femoire',
                    url: 'https://femoire.com/',
                    logo_url: require('@/assets/images/project_logo/Femoire_logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },
                {
                    name: 'SupermamaLab',
                    url: 'https://www.supermamalab.com.my/',
                    logo_url: require('@/assets/images/project_logo/Supermamalab_logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },
                {
                    name: 'Dayang Ros',
                    url: 'https://www.dayangros.com/',
                    logo_url: require('@/assets/images/project_logo/DayangRos_Logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },                                
                {
                    name: 'Casebang MY',
                    url: 'https://www.shopcasebang.com.my/',
                    logo_url: require('@/assets/images/project_logo/Casebang_logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                }, 
                {
                    name: 'Zucca',
                    url: 'https://www.shopzucca.com/',
                    logo_url: require('@/assets/images/project_logo/ZUCCA_logo.png'),
                    background_color: "#E9E2D1",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },
                {
                    name: 'Ventamin',
                    url: 'https://ventamin.com/',
                    logo_url: require('@/assets/images/project_logo/Ventamin_logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"           
                },       
                {
                    name: 'Spectrum Health',
                    url: 'https://spectrumhealth.com.my/',
                    logo_url: require('@/assets/images/project_logo/SpectrumHealth_Logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },       
                {
                    name: 'Vitera',
                    url: 'https://myvitera.com/',
                    logo_url: require('@/assets/images/project_logo/Vitera_Logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },       
                {
                    name: 'Kintry',
                    url: 'https://kintry.co/',
                    logo_url: require('@/assets/images/project_logo/Kintry_logo.png'),
                    background_color: "#C7E6ED",
                    filter: "grayscale(100%) brightness(1)"
                },                       
                {
                    name: 'SWAN Bag',
                    url: 'https://swanbag.com/',
                    logo_url: require('@/assets/images/project_logo/SWAN_Logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },      
                {
                    name: 'Nihon Skin',
                    url: 'https://nihonskin.com/',
                    logo_url: require('@/assets/images/project_logo/NihonSkin_logo.png'),
                    background_color: "#F6EDD9",
                    filter: "grayscale(100%) brightness(0) invert(1)"            
                },                                 
                {
                    name: 'ByThian',
                    url: 'https://bythian.my/',
                    logo_url: require('@/assets/images/project_logo/Bythian_logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },
                {
                    name: 'Artelia',
                    url: 'https://artelia.com.my/',
                    logo_url: require('@/assets/images/project_logo/Artelia_Logo.png'),
                    background_color: "#F8F5EE",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },                                
                {
                    name: 'Mikosa Jewellery',
                    url: 'https://www.mikosajewellery.com/',
                    logo_url: require('@/assets/images/project_logo/MIKOSA_LOGO_BLACK.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },     
                {
                    name: 'Heralabel',
                    url: 'https://heralabel.co/',
                    logo_url: require('@/assets/images/project_logo/Hera_logo.png'),
                    background_color: "#CDE7F4",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },                                                                      
                {
                    name: 'Deskbird',
                    url: 'https://www.deskbird.co.nz/',
                    logo_url: require('@/assets/images/project_logo/deskbird_logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },
                {
                    name: 'Nestbloom',
                    url: 'https://nestbloom.com.my/',
                    logo_url: require('@/assets/images/project_logo/NestBloom_Logo.png'),
                    background_color: "#EAACA6",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },
                {
                    name: 'Geo Coloured Lenses',
                    url: 'https://geocolouredlenses.com/',
                    logo_url: require('@/assets/images/project_logo/GeoColouredLens_logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },             
                {
                    name: 'Alcean',
                    url: 'https://alcean.com/pages/alcean',
                    logo_url: require('@/assets/images/project_logo/Alcean_logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(1)"
                },
                {
                    name: 'Thong Kee',
                    url: 'https://thongkee.com/',
                    logo_url: require('@/assets/images/project_logo/Thongkee_Logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(1)"
                },   
                {
                    name: 'Kyut Skin',
                    url: 'https://kyutskin.com/',
                    logo_url: require('@/assets/images/project_logo/Kyutskin_logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },
                {
                    name: 'Salang Design',
                    url: 'https://salangdesign.com/',
                    logo_url: require('@/assets/images/project_logo/Salang_logo.png'),
                    background_color: "#D2DAFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },                               
                {
                    name: 'Preface',
                    url: 'https://prefaceskin.com/',
                    logo_url: require('@/assets/images/project_logo/Preface_logo.png'),
                    background_color: "#E66E32",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },
                {
                    name: 'Complement',
                    url: 'https://complementcandles.com/',
                    logo_url: require('@/assets/images/project_logo/Complement_logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },
                {
                    name: 'Mates',
                    url: 'https://my.matesfood.co/',
                    logo_url: require('@/assets/images/project_logo/Mates_logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },
                {
                    name: 'AGT Brake',
                    url: 'https://www.agtbrake.com/',
                    logo_url: require('@/assets/images/project_logo/AGT_logo.png'),
                    background_color: "#000000",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                },                      
                {
                    name: 'Titan Autohaus',
                    url: 'https://www.titanautohaus.com/',
                    logo_url: require('@/assets/images/project_logo/TitanAutohaus_logo.png'),
                    background_color: "#FFFFFF",
                    filter: "grayscale(100%) brightness(0) invert(1)"
                }                      
                // {
                //     name: 'OCDEE',
                //     url: 'https://ocdee.co/',
                //     logo_url: require('@/assets/images/project_logo/Ocdee_logo.png')
                // },             
                // {
                //   name: 'Keyyes',
                //   url: 'https://keyyes.co/',
                //   logo_url: require('@/assets/images/project_logo/Keyyes_logo.png')            
                // }, 
                // {
                //     name: 'Jin Yuan',
                //     url: 'https://www.jinyuan.com.my/',
                //     logo_url: require('@/assets/images/project_logo/JinYuan_logo.png')
                // },                
                // {
                //     name: 'Respi Theory',
                //     url: 'https://www.respitheory.com/',
                //     logo_url: require('@/assets/images/project_logo/Respitheory_logo.png')
                // },                
                // {
                //     name: 'LAX',
                //     url: 'https://heylax.com/',
                //     logo_url: require('@/assets/images/project_logo/Lax_logo.png')
                // },
                // {
                //     name: 'SKG Malaysia',
                //     url: 'https://skgmalaysia.com/',
                //     logo_url: require('@/assets/images/project_logo/SKG_logo.png')
                // }
            ],
            calendlyUrl: "https://calendly.com/boolland?hide_gdpr_banner=1&primary_color=3645d3"
        }
    },
    methods: {
        splitText(el) {
            const text = el.innerText;
            el.innerHTML = text
            .split("")
            .map(char => {
                if (char === " ") return `<span class="char">&nbsp;</span>`;
                return `<span class="char">${char}</span>`;
            })
            .join("");
        },

        initHeroBlur(gsap, ScrollTrigger) {
            gsap.fromTo(
                this.$refs.heroSection,
                { filter: "blur(0px)" },
                {
                    filter: "blur(4px)",
                    ease: "none",
                    scrollTrigger: {
                        trigger: this.$refs.heroSection,
                        start: "center 30%",
                        end: "center 20%",
                        scrub: 1,
                        // markers: true
                    }
                }
            );
        },

        initAboutTextAnimation(gsap, ScrollTrigger) {
            const el = this.$refs.aboutUsDesc;

            // split text
            this.splitText(el);

            const chars = el.querySelectorAll(".char");

            // initial state
            gsap.set(chars, {
                opacity: 0.15,                                
            });

            // animation
            gsap.to(chars, {
                opacity: 1,                            
                stagger: 0.2,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: el,
                    start: "top 70%",
                    end: "top 50%",
                    scrub: 1,
                    // markers: true
                }
            });
        },

        initializeCalendly() {
            if (window.Calendly) {
                window.Calendly.initInlineWidget({
                url: this.calendlyUrl,
                parentElement: this.$refs.calendlyWidget
                });
            }
        },

        initCTAFollow(gsap) {
            const btn = this.$refs.ctaBtn;
            if (!btn) return;

            const xTo = gsap.quickTo(btn, "x", { duration: 0.4, ease: "power3.out" });
            const yTo = gsap.quickTo(btn, "y", { duration: 0.4, ease: "power3.out" });

            const move = (e) => {
                const rect = btn.getBoundingClientRect();
                const centerX = rect.left + rect.width / 2;
                const centerY = rect.top + rect.height / 2;

                const distanceX = e.clientX - centerX;
                const distanceY = e.clientY - centerY;

                // Clamp the movement to a more subtle, max 20px, and scale down for subtle effect
                const maxMove = 20;
                const moveX = Math.max(Math.min(distanceX * 0.12, maxMove), -maxMove);
                const moveY = Math.max(Math.min(distanceY * 0.12, maxMove), -maxMove);

                xTo(moveX);
                yTo(moveY);
            };

            const reset = () => {
                xTo(0);
                yTo(0);
            };

            window.addEventListener("mousemove", move);
            btn.addEventListener("mouseleave", reset);

            this._ctaCleanup = () => {
                window.removeEventListener("mousemove", move);
                btn.removeEventListener("mouseleave", reset);
            };
        },
        handleCTAClick() {
            const btn = this.$refs.ctaBtn;
            const overlay = this.$el.querySelector(".calendly_overlay");

            if (!btn || !overlay) return;

            const rect = btn.getBoundingClientRect();

            const circle = document.createElement("div");
            circle.classList.add("cta-expand-circle");

            circle.style.left = rect.left + rect.width / 2 + "px";
            circle.style.top = rect.top + rect.height / 2 + "px";

            document.body.appendChild(circle);

            requestAnimationFrame(() => {
                circle.classList.add("active");
            });

            setTimeout(() => {
                overlay.classList.remove("calendly_hide");
                overlay.classList.add("calendly_active");
                // circle.remove();
            }, 700);
        }
    },
    mounted() {
        const gsap = window.gsap;
        const ScrollTrigger = window.ScrollTrigger;

        if (!gsap || !ScrollTrigger) return;

        gsap.registerPlugin(ScrollTrigger);

        this.ctx = gsap.context(() => {
            this.initHeroBlur(gsap, ScrollTrigger);
            this.initAboutTextAnimation(gsap, ScrollTrigger);
            this.initCTAFollow(gsap);


            // // Scroll Snap using GSAP (works with Lenis)
            // const sections = gsap.utils.toArray([
            //     // ".hero_section",
            //     ".about_section"
            // ]);

            // ScrollTrigger.create({
            //     trigger: ".about_section",
            //     start: "center 80%",
            //     end: "center 20%",                
            //     // start: 0,
            //     // end: () => window.innerHeight * (sections.length - 1),                
            //     scrub: false,
            //     snap: {
            //         snapTo: 1 / (sections.length - 1),
            //         delay: 0.1,
            //         duration: 1.2,
            //         ease: "power2.inOut",                    
            //         directional: true,
            //     },
            //     markers: true
            // });

        }, this.$el);


        // Load Calendly widget script
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://assets.calendly.com/assets/external/widget.js";
        script.async = true;
        script.onload = this.initializeCalendly;
        document.head.appendChild(script);
  },

  beforeDestroy() {
    this.ctx && this.ctx.revert();
    this._ctaCleanup && this._ctaCleanup();
  }
}
</script>

<style lang="scss" scoped>
    .about_section {        
        margin-inline: 21rem;
        min-height: 100vh;
        min-height: 100dvh;
        display:flex;
        align-items: center;        

        @media screen and (max-width: 767px){
            & {                
                margin-inline: 2rem;
            }
        }
        
        .about_eyebrow {
            text-transform: uppercase;            
            letter-spacing: 0.2rem;
            color: var(--blue);
            margin-bottom: 1rem;
            display: flex;
            align-items: center;
            gap: 1rem;            
            &::before {
                content: '';
                width: 2rem;
                height: 0.05rem;
                background: var(--blue);
            }
            .about_title{
                margin-bottom: 0px;
                font-weight: normal;
            }
        }
        .about_us_desc {
            white-space: normal;
            word-break: normal;
            overflow-wrap: break-word;
        }
    }

    .service_section {
        padding-bottom: 16rem;
        margin-inline: 6rem;

        @media screen and (max-width: 767px){
            & {
                margin-inline: 2rem;
            }
        }

        .service_section_title_wrapper{
            .service_section_title{
                font-weight: 500;
                top: 15rem;

                @media screen and (max-width: 767px){
                    & {
                        margin-bottom: 8rem;
                    }
                }
            }
        }
        .service_list{            
            .service_block{
                margin-left: 6rem;
                text-wrap: balance;

                &:not(:last-child) {                    
                    margin-bottom: 8rem;
                }

                .service_title{
                    font-weight: 600;
                    margin-bottom: 2rem;
                }
                .service_desc{
                    color: var(--secondary);
                }

                @media screen and (max-width: 767px){
                    & {
                        margin-left: 0rem;
                    }
                }
            }
        }
    }

    .portfolio_section {
        padding-inline: 2rem;
        padding-bottom: 8rem;

        .portfolio_wrapper{
            gap: 2rem;

            @media screen and (max-width: 767px){
                & {
                    gap: 1.5rem;
                }
            }
            .project_box {
                padding: 2rem;;
                width: 10.25rem;
                border: 1px solid rgba(255,255,255,0.1);
                border-radius: 2rem;
                background-color: #101010;   
                transition: background-color 0.2s ease;

                @media screen and (max-width: 767px){
                    & {
                      width: 11rem;  
                    }
                }

                &:hover{
                    background-color: var(--project-background);
                    img{
                        filter: unset;
                    }
                }
                img{
                    width: 100%;
                    aspect-ratio: 1;
                    object-fit: contain;
                    filter: var(--project-filter);
                    transition: filter 0.2s ease;
                }
            }
        }
    }    

    .calendly_section {
        padding-inline: 2rem;
        padding-block: 8rem;

        .calendly_cta_wrapper {
            h2 {
                margin-bottom: 0px;
                padding-bottom: 4rem;
                font-weight: 700;
            }
            .calendly_cta {
                padding: 1rem 4rem;
                background: #101010;
                border: 1px solid hsla(0,0%,100%,.1);
                border-radius: 8rem;
                font-size: 1.8rem;                
                font-weight: bold;
                color: #FFFFFF;
                &:hover{
                    background: #FFFFFF;
                    color: #0C0C0C;
                }
            }
        }
        .calendly_overlay{
            pointer-events: none;
            position: fixed;
            left: 0%;
            top: 0%;
            height: 100dvh;
            width: 100%;
            z-index: 100;
            background: #FFFFFF;
            opacity: 0;
            // transition: opacity 0.4s;
            
            &.calendly_active{
                opacity: 1;
                pointer-events: all;
            }

        }   
    }

    .gradient-glow {        
        background: linear-gradient(135deg, #3645d3 0%, #3645d3 40%, #00d4ff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;

        /* Animation Styles */
        background-size: 200% 150%; /* Expand background to allow movement */
        animation: gradient-rotate 5s cubic-bezier(0.645, 0.045, 0.355, 1) infinite;
    }

    @keyframes gradient-rotate {
        0% {
            background-position: 0% 50%;
        }
        50% {
            background-position: 100% 50%;
        }
        100% {
            background-position: 0% 50%;
        }
    }    
</style>
<style>
.cta-expand-circle {
    position: fixed;
    width: 1rem;
    height: 1rem;
    background: #ffffff;
    border-radius: 50%;
    transform: translate(-50%, -50%) scale(0);
    z-index: 99;
    pointer-events: none;
    transition: transform 0.5s cubic-bezier(0.22, 1, 0.36, 1);
}

.cta-expand-circle.active {
    transform: translate(-50%, -50%) scale(200);
}

</style>


// WEBPACK FOOTER //
// src/views/portfolio/Content/Homepage.vue